import { request } from '@/util/http'

export const getList = (current, size, params) => {
  return request({
    url: '/health/drugplan/list',
    method: 'get',
    params: {
      ...params,
      current,
      size
    }
  })
}

export const remove = (ids) => {
  return request({
    url: '/health/drugplan/remove',
    method: 'post',
    params: {
      ids
    }
  })
}

export const getSubmit = (row) => {
  return request({
    url: '/health/drugplan/submit',
    method: 'post',
    data: row
  })
}

export const getDetail = (wxUserId) => {
  return request({
    url: '/health/drugplan/detail',
    method: 'get',
    params: {
      wxUserId
    }
  })
}

export const getCommonSubmit = (row) => {
  return request({
    url: '/health/drugplan/submitCommonVip',
    method: 'post',
    data: row
  })
}

export const getCommonDetail = (wxUserId) => {
  return request({
    url: '/health/drugplan/commonDetail',
    method: 'get',
    params: {
      wxUserId
    }
  })
}

